import axios from 'axios';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';
import { IProjectAsset } from '../types';

interface ICopyDealDocumentsToProjectParams {
    projectUuid: string;
    dealId: number;
    documentIds: number[];
}

const copyDealDocumentsToProject = async ({
    projectUuid,
    dealId,
    documentIds,
}: ICopyDealDocumentsToProjectParams): Promise<IProjectAsset[]> => {
    try {
        const response = await axiosInstance.post(
            API_ENDPOINTS.PROJECT_ASSETS_FROM_DEAL_DOCUMENTS(projectUuid),
            { dealId, documentIds },
        );
        return response.data;
    } catch (error: unknown) {
        if (axios.isAxiosError(error)) {
            const detail = error.response?.data?.detail;
            if (typeof detail === 'string') {
                throw new Error(detail);
            }
        }
        throw new Error('An unexpected error occurred. Please try again.');
    }
};

export const useCopyDealDocumentsToProject = () => useMutation({
    mutationFn: copyDealDocumentsToProject,
});

export default useCopyDealDocumentsToProject;
